function getLocalStorageItem(key, fallbackValue = null) {
  if (typeof window === "undefined") {
    return fallbackValue
  }

  try {
    const value = window.localStorage.getItem(key)
    return value === null ? fallbackValue : value
  } catch (error) {
    return fallbackValue
  }
}

function setLocalStorageItem(key, value) {
  if (typeof window === "undefined") {
    return
  }

  try {
    window.localStorage.setItem(key, String(value))
  } catch (error) {
    // Ignore write failures and keep runtime behavior in memory.
  }
}

function clearLocalStorageItem(key) {
  if (typeof window === "undefined") {
    return
  }

  try {
    window.localStorage.removeItem(key)
  } catch (error) {
    // Ignore clear failures.
  }
}

function getLocalStorageBoolean(key, fallbackValue = false) {
  const value = getLocalStorageItem(key, null)

  if (value === "true") {
    return true
  }

  if (value === "false") {
    return false
  }

  return fallbackValue
}

export {
  getLocalStorageItem,
  setLocalStorageItem,
  clearLocalStorageItem,
  getLocalStorageBoolean,
}